import { Button, DatePicker, Divider, Flex, Tabs } from "antd";
import dayjs from "dayjs";
import { useState } from "react";
import { ProductGraphDayBar } from "./ProductGraphDayBar";
import { TravelPeopleDayLine } from "./TravelPeopleDayLine";
import { DistributionGraphDayBar } from "./DistributionGraphDayBar";

export const dateFormat = "YYYY-MM-DD";
export const dateFormatByMonth = "YYYY-MM";

export function DayGraph() {
	const [selectedDateByDay, setSelectedDateByDay] = useState({
		startDate: dayjs().startOf("month").format(dateFormat),
		endDate: dayjs().endOf("month").format(dateFormat),
	});

	const handleDayChange = (data) => {
		setSelectedDateByDay({
			startDate: dayjs().subtract(data, "day").format(dateFormat),
			endDate: dayjs().format(dateFormat),
		});
	};

	const mappingData = {
		day: [
			{
				data: 7,
				label: "过去7天",
			},
			{
				data: 30,
				label: "过去30天",
			},
			{
				data: 60,
				label: "过去60天",
			},
		],
	};

	return (
		<div style={{ minWidth: "800px" }}>
			<Flex gap="large" justify="center" align="center">
				<Flex gap="large" justify="flex-start" align="center">
					<DatePicker.RangePicker
						key="day"
						allowEmpty={[false, false]}
						value={[
							dayjs(selectedDateByDay.startDate, dateFormat),
							dayjs(selectedDateByDay.endDate, dateFormat),
						]}
						format={dateFormat}
						onChange={(date, dateString) => {
							setSelectedDateByDay({
								startDate: dateString[0],
								endDate: dateString[1],
							});
						}}
						allowClear={false}
					/>

					<Divider type="vertical" style={{ height: "40px" }} />

					<Flex
						gap="10px"
						justify="flex-start"
						align="center"
						wrap="wrap"
						style={{ width: "300px", height: "92px" }}
					>
						{mappingData.day.map((d) => (
							<Button
								onClick={() => handleDayChange(d.data)}
								size="small"
							>
								{d.label}
							</Button>
						))}
					</Flex>
				</Flex>
			</Flex>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					gap: "30px",
					marginBottom: "100px",
				}}
			>
				<TravelPeopleDayLine selectedDateByDay={selectedDateByDay} />
				<ProductGraphDayBar selectedDateByDay={selectedDateByDay} />
				<DistributionGraphDayBar
					selectedDateByDay={selectedDateByDay}
				/>
			</div>
		</div>
	);
}
